import React from 'react';
import Button from "../../Button";
import NavigationClose from "../../../icons/NavigationClose";
import colors from "../../../utils/colors";
import { createStyles } from "./styles";








var SidebarProposalCard = function SidebarProposalCard(_ref)




{var title = _ref.title,portfolioId = _ref.portfolioId,versionsCount = _ref.versionsCount,removeFromProposal = _ref.removeFromProposal;
  var classes = createStyles(versionsCount);
  return /*#__PURE__*/(
    React.createElement("div", { className: classes.proposalCard }, /*#__PURE__*/
    React.createElement("p", { className: classes.titleWrapper }, /*#__PURE__*/
    React.createElement("span", { className: classes.productTitle }, title),
    versionsCount > 1 && /*#__PURE__*/
    React.createElement("span", { className: classes.versionsCount }, "".concat(versionsCount, " versions"))), /*#__PURE__*/


    React.createElement(Button, {
      type: "icon",
      iconSize: "2.4rem",
      color: "custom",
      customColor: colors.red[500],
      className: classes.removeButton,
      onClick: function onClick() {
        removeFromProposal(portfolioId);
      } }, /*#__PURE__*/

    React.createElement(NavigationClose, null))));



};

export default SidebarProposalCard;
//# sourceMappingURL=index.js.map